var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnbStep4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / onb-step-4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-17.6%",
    y: "-31.3%",
    width: "135.2%",
    height: "162.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.9805992%",
    y1: "21.4895888%",
    x2: "84.0732803%",
    y2: "90.9221956%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC124",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89422",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.2557535,9.84202286 C52.9955077,9.29787256 52.8298968,9.25055514 52.7352619,9.25055514 C49.967193,8.56445259 42.4673823,14.5501059 39.651996,16.7976833 C38.8002824,17.4837858 38.019545,18.0989122 37.2861251,18.5720864 C30.6380279,23.564074 20.393807,24.8179855 14.4554711,17.3181748 C13.2826035,15.7470595 12.827273,13.7539144 13.2015595,11.8293544 C13.6983924,8.28054808 16.7030484,4.04563921 20.4647831,0 C17.6149696,0.828717988 14.915531,2.10655873 12.4681395,3.78539341 C11.8507495,4.24014921 11.1056212,4.48852531 10.3388557,4.49515467 L0,4.49515467 L0,42.8695804 L6.10394687,42.8695804 C7.34254608,42.8659405 8.49218271,43.5126111 9.1322616,44.5730074 C9.1322616,44.5730074 17.5784206,58.3660346 22.3101624,66.1970672 C22.8041985,67.1175173 23.6629976,67.7873806 24.6760333,68.0424465 C26.6100373,68.3254743 28.5846504,68.063285 30.3777821,67.2853678 C27.538737,62.0567932 25.0309139,57.3723688 25.0309139,57.3013927 C24.3378939,56.1667688 24.3372071,54.7399536 25.0291346,53.6046631 C25.7210621,52.4693725 26.9895234,51.8160672 28.315586,51.912017 C29.6416486,52.0079668 30.802847,52.8370748 31.3241305,54.0601496 C31.3241305,54.0601496 34.5417149,60.28239 37.8302754,66.2917021 C39.2609053,67.116294 40.9310707,67.4252746 42.5620171,67.1670743 C43.702019,66.8762229 44.7106086,66.2093868 45.4247209,65.2743776 L37.9249102,50.7242717 C37.0233326,48.9799148 37.7065401,46.834961 39.450897,45.9333833 C41.1952539,45.0318056 43.3402077,45.715013 44.2417855,47.4593699 L52.2620877,63.050459 C55.1985665,64.5508617 58.7640824,64.0184113 61.1341035,61.7255713 C58.4843282,56.1894334 52.3330639,44.4310551 52.2857465,44.3127616 C51.6983017,43.1885867 51.7552205,41.8364083 52.4350621,40.7655787 C53.1149037,39.6947492 54.314384,39.0679531 55.5816704,39.1212985 C56.8489568,39.1746438 57.9915183,39.9000262 58.578963,41.0242011 C58.8392088,41.5210339 64.9904731,53.3267296 67.6402485,58.8865262 C68.2187252,60.1413249 69.4534074,60.9644464 70.8341742,61.01581 C72.3733001,61.162714 73.8782907,60.4998015 74.8088372,59.2650656 C75.6192685,57.5568591 75.4849084,55.5504144 74.4539566,53.9655148 C70.2663651,45.495697 56.9228534,17.6020793 53.2557535,9.84202286 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "56.9004782%",
    x2: "50.9086715%",
    y2: "72.7429778%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83BFFC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C8BF7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.1504191%",
    y1: "44.4856839%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.2928379,0 L2.36587088,0 C1.05923647,0 0,1.05923647 0,2.36587088 L0,48.500353 C0,49.8069875 1.05923647,50.8662437 2.36587088,50.8662437 L17.22354,50.8662437 C18.4513447,50.8712058 19.4789177,49.9361143 19.5894109,48.7132814 L23.7533436,2.60245797 C23.8154892,1.92218458 23.5805662,1.24825158 23.1090059,0.754020066 C22.6374455,0.259788551 21.975278,-0.00649825237 21.2928379,0.0236587088 L21.2928379,0 Z",
    id: "path-8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-/-onb-step-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Handshake_3325257",
    filter: "url(#filter-1)",
    transform: "translate(2.375937, 34.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-30",
    transform: "translate(30.860568, 13.305786)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.881665,-7.38608465 L97.0135398,-44.7062287 L11.5556737,55.2961141 C18.5326373,75.6859011 30.3470224,82.3097408 46.998829,75.167633 C58.1114503,70.401331 83.192787,79.109112 80.9187176,57.0765424 C80.1630308,49.7549885 87.1506801,28.2674461 101.881665,-7.38608465 Z",
    fillOpacity: 0.15,
    fill: "url(#linearGradient-5)",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.0377116,2.89595382 C70.241413,5.59079613 66.6000791,8.4975442 63.1310468,11.6023587 C62.9824347,11.7699766 62.81582,11.9207232 62.6342139,12.0518741 C55.7495297,18.2741145 50.8048595,24.2361092 51.0651053,26.3890517 C54.5192768,30.6476192 60.8361521,28.5419942 63.9827603,26.1761233 C64.574228,25.7266078 65.307648,25.1587988 66.0883854,24.5200137 C72.949411,19.0785106 79.5501907,14.2994515 85.2046221,15.6006804 C87.5932634,16.1665698 89.5698776,17.8357108 90.5278316,20.0958351 C93.745416,26.5546626 103.587439,47.4926199 109.147235,58.8961176 C110.788523,58.8669796 112.425421,58.7167329 114.044588,58.4466021 L114.044588,16.0738546 C106.900542,10.957415 99.493079,6.2191659 91.8527193,1.87862934 C89.5105071,0.766670028 81.3245939,-2.21432728 74.0377116,2.89595382 Z",
    id: "Path",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7629561,16.2394656 L23.7629561,62.350289 C23.7629561,63.6569235 22.7037189,64.7161797 21.3970845,64.7161797 L6.53941535,64.7161797 C5.3116107,64.7211418 4.28403769,63.7860503 4.17354447,62.5632174 L0.00961171948,16.452394 C-0.0503490498,15.7889281 0.172180887,15.1309276 0.622532118,14.6400448 C1.07288335,14.1491619 1.70931829,13.8708907 2.3754826,13.8735947 L21.3024496,13.8735947 C21.9461483,13.8478259 22.5725201,14.0856637 23.036891,14.5321741 C23.5012619,14.9786846 23.7634709,15.5952516 23.7629561,16.2394656 L23.7629561,16.2394656 Z",
    id: "Path",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-30",
    transform: "translate(121.236836, 13.849936)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#58585C",
    fillRule: "nonzero",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5053978,-10.930235 L78.6372722,-48.250379 L-6.82059397,51.7519638 C0.156369636,72.1417508 11.9707547,78.7655905 28.6225613,71.6234827 C39.7351827,66.8571807 64.8165193,75.5649617 62.5424499,53.5323921 C61.7867632,46.2108382 68.7744125,24.7232958 83.5053978,-10.930235 Z",
    fillOpacity: 0.15,
    fill: "url(#linearGradient-5)",
    mask: "url(#mask-9)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnbStep4);
export default __webpack_public_path__ + "static/media/onb-step-4.f80e610103454fcae46ed904cf7bf267.svg";
export { ForwardRef as ReactComponent };